import React from "react";
import { GAevent } from "../../../../utils/googleAnalyticsHelper";

import styles from "./ContactUsButton.module.scss";

const ContactUsButton = ({ product }) => {
  const { ContactUs, Model } = product;

  const handleClick = () => {
    GAevent("Guest-User", "click", `Contact Us Button - ${Model}`);
  };

  return (
    <>
      <button className={styles.btn}>
        <a className={`contactUsButton - ${Model}`} href={ContactUs} rel="noreferrer" target="_blank" onClick={handleClick}>
          Contact Us
        </a>
      </button>
    </>
  );
};

export { ContactUsButton };
